import { render, staticRenderFns } from "./MiniModeBook.vue?vue&type=template&id=652534b1&scoped=true&"
import script from "@/scripts/MiniMode/MiniModeBook/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MiniMode/MiniModeBook/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652534b1",
  null
  
)

export default component.exports